<template>
  <div v-if="address" class="address-links">
    <a v-if="website" :href="website" target="_blank" class="link with-arrow">
      <SpriteSymbol name="home" />
      <span itemprop="url">{{ $texts('website', 'Website') }}</span>
    </a>
    <a v-if="email" :href="'mailto:' + email" target="_blank" class="link">
      <SpriteSymbol name="email" />
      <span itemprop="email">{{ email }}</span>
    </a>
    <a v-if="phone" :href="phone" target="_blank" class="link">
      <SpriteSymbol name="phone" />
      <span itemprop="telephone">{{ phoneText }}</span>
    </a>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import type { AddressCardFragment } from '#graphql-operations'
import { buildPhoneUri } from '~/helpers'
const { $texts } = useEasyTexts()

const props = defineProps<{
  address?: AddressCardFragment
}>()

const email = computed(() => props.address?.email || '')
const website = computed(() => props.address?.website?.url?.path || '')
const phone = computed(() => buildPhoneUri(props.address?.phone || ''))
const phoneText = computed(() => props.address?.phone || '')
</script>

<style>
@reference '~/assets/css/tailwind.css';
.address-links {
  @apply desktop:mt-size-6;
  a {
    @apply relative -ml-[0.1em] block py-0.5 pl-[1.25em] leading-none desktop:pl-[1.5em];
    &:not(:last-child) {
      @apply mb-3;
    }
    svg {
      @apply absolute top-[0.2em] left-0 size-[1em] text-[0.9em] desktop:top-0.5 desktop:text-[1em];
    }
  }
}
</style>
